import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    back: 'Back',
    description:
      'Your logo will be automatically added to future quotes and invoices',
    helpLink: 'A problem with adding your logo?',
    removeFileAriaLabel: 'Remove file',
    retry: 'Retry',
    submit: 'Save my logo',
    title: 'Add your logo to your quotes and invoices',
  },
  fr: {
    back: 'Retour',
    description:
      'Votre logo sera automatiquement ajouté à vos futurs devis et factures',
    helpLink: 'Un problème avec l’ajout de votre logo ?',
    removeFileAriaLabel: 'Supprimer le fichier',
    retry: 'Réessayer',
    submit: 'Valider mon logo',
    title: 'Ajoutez votre logo sur vos devis et factures',
  },
} as const);

export default locales;
